<template>
  <div class="kkm-server-proxy">
    <div v-if="false" class="" style="padding: 100px 100px 100px 500px; max-width: 1500px">
      <v-text-field v-model="commandId" outlined placeholder="Проверка статуса команды KKMServer" />
      <v-btn
        color="success"
        class="mb-3"
        block
        @click="sendKKmCommand"
      >
        Проверить
      </v-btn>
      <div v-if="status" class="status mb-3">
        {{ status }}
      </div>

      <div v-if="error" class="color-red mb-3">
        {{ error }}
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import kkmServerProxy from '@/services/kkm-server/kkmServerProxy'
  import kkmServerApiClient from '@/services/kkm-server/kkmServerApiClient'

  export default {
    name: 'KkmServerProxy',
    data () {
      return {
        commandId: null,
        status: null,
        error: null,
      }
    },
    computed: {
      ...mapGetters({
        kkmServerProxyEnabled: 'printServer/isKkmServerProxyEnabled',
        kkmServerFilialId: 'printServer/getKkmServerFilialId',
        kkmServerToken: 'printServer/getKkmServerToken',
      }),
    },
    created () {
      if (this.kkmServerProxyEnabled) {
        kkmServerProxy.init({
          filialId: this.kkmServerFilialId,
          token: this.kkmServerToken,
        })
      }
    },
    methods: {
      sendKKmCommand () {
        this.status = null
        this.error = null

        const command = {
          Command: 'GetRezult',
          IdCommand: this.commandId,
        }

        kkmServerApiClient.sendCommand(command)
          .then((response) => {
            console.log('KKM Command Response:', response)
            this.status = response
          })
          .catch((error) => {
            this.error = error
          })
      },
    },
  }
</script>

<style scoped lang="less">

</style>
